import styled from '@emotion/styled';

export const ProfileButton = styled.button<{ active: boolean }>`
    display: grid;
    grid-template-columns: 28px 30px minmax(0, 1fr) 18px;
    align-items: center;
    gap: 7px;
    width: clamp(210px, 22vw, 270px);
    height: 40px;
    min-width: 0;
    padding: 4px 9px 4px 6px;
    border: 1px solid
        ${({ active }) => (active ? 'rgba(131, 83, 226, 0.42)' : 'rgba(148, 163, 184, 0.2)')};
    border-radius: 14px;
    background: ${({ active }) =>
        active
            ? 'linear-gradient(135deg, rgba(131, 83, 226, 0.13), rgba(131, 83, 226, 0.05))'
            : 'rgba(255, 255, 255, 0.78)'};
    color: #111827;
    font: inherit;
    text-align: left;
    cursor: pointer;
    box-shadow: ${({ active }) => (active ? '0 8px 20px rgba(131, 83, 226, 0.11)' : 'none')};
    transition:
        transform 0.15s ease,
        border-color 0.15s ease,
        box-shadow 0.15s ease;

    &:hover:not(:disabled) {
        transform: translateY(-1px);
        border-color: rgba(131, 83, 226, 0.38);
        box-shadow: 0 8px 18px rgba(15, 23, 42, 0.07);
    }

    &:focus-visible {
        outline: 3px solid rgba(131, 83, 226, 0.2);
        outline-offset: 2px;
    }

    @media (max-width: 768px) {
        width: min(230px, 42vw);
    }
`;

export const Avatar = styled.span<{ active: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background: ${({ active }) =>
        active
            ? 'linear-gradient(135deg, #8353e2 0%, #6d41d8 100%)'
            : 'linear-gradient(135deg, #ede9fe 0%, #f5f3ff 100%)'};
    color: ${({ active }) => (active ? '#ffffff' : '#6d41d8')};
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.04em;
`;

export const ProfileText = styled.span`
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
`;

export const Name = styled.span`
    overflow: hidden;
    color: #111827;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const Relationship = styled.span`
    overflow: hidden;
    color: #6d41d8;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 0.04em;
    line-height: 1.2;
    text-overflow: ellipsis;
    text-transform: uppercase;
    white-space: nowrap;
`;

export const ActiveIndicator = styled.span<{ active: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: 1px solid
        ${({ active }) => (active ? 'rgba(34, 197, 94, 0.28)' : 'rgba(148, 163, 184, 0.2)')};
    border-radius: 999px;
    background: ${({ active }) => (active ? 'rgba(34, 197, 94, 0.13)' : 'transparent')};
    color: ${({ active }) => (active ? '#15803d' : '#94a3b8')};
`;

export const SwitchIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 999px;
    background: rgba(131, 83, 226, 0.08);
    color: #6d41d8;
`;
